import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  useDisclosure,
  useToast,
} from '@chakra-ui/react'
import { getFunctions, httpsCallable } from 'firebase/functions'
import { useRef, useState } from 'react'
import useHandleError from '../../../../hooks/useHandleError'
import { primaryServices } from '../../../../utils/firebaseServiceContext'

export const Email = ({ uid }: { uid: string }) => {
  const { isOpen, onOpen, onClose: _onClose } = useDisclosure()
  const cancelRef = useRef<any>()
  const handleError = useHandleError()
  const [input, setInput] = useState('')
  const [loading, setLoading] = useState(false)
  const toast = useToast()

  const onClose = () => {
    setInput('')
    _onClose()
  }

  return (
    <>
      <Box>
        <Button variant='link' onClick={onOpen}>
          Change Email
        </Button>
      </Box>
      <AlertDialog
        isOpen={isOpen}
        onClose={onClose}
        leastDestructiveRef={cancelRef}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader>Change Email</AlertDialogHeader>
            <AlertDialogCloseButton />
            <AlertDialogBody>
              <FormControl>
                <FormLabel>New Email</FormLabel>
                <Input
                  value={input}
                  onChange={(e) => setInput(e.target.value)}
                  type='email'
                />
              </FormControl>
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose} colorScheme='gray'>
                Cancel
              </Button>
              <Button
                ml={3}
                isDisabled={loading || input.length === 0}
                isLoading={loading}
                onClick={async () => {
                  setLoading(true)

                  try {
                    const changeEmail = httpsCallable(
                      primaryServices.functions,
                      'changeEmail'
                    )
                    await changeEmail({ uid, email: input })
                    onClose()
                    toast({
                      status: 'success',
                      description:
                        'Successfully changed email to ' + input.toLowerCase(),
                    })
                  } catch (e) {
                    handleError(e)
                  } finally {
                    setLoading(false)
                  }
                }}
              >
                Submit
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  )
}
